export class Parceiro {
    id: number
}